<template>
  <v-card class="overflow-y-auto">
    <v-form ref="form" @submit.prevent="save">
      <v-card-title> Listing Zone</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="zone.name"
          label="Name"
          :rules="[required]"
          outlined
          rows="4"
        />
        <v-text-field
          v-model="zone.company_name"
          label="Company Name"
          outlined
          dense
          placeholder="Example: Booking Corp"
          class="mt-2 mb-2"
        />
        <multi-property-picker v-model="listingIds" />
        <currency-picker v-model="zone.currency" />
        <v-text-field
          v-model="zone.processing_rate"
          class="mt-2 mb-2"
          outlined
          dense
          :disabled="!isAdmin"
          label="Processing fee"
          required
        />
        <v-text-field
          v-model.number="zone.vat_rate"
          class="mt-2 mb-2"
          outlined
          dense
          label="VAT Rate (%)"
          type="number"
          step="0.01"
          min="0"
          max="100"
          hint="Zone-level VAT rate. Overrides app-level setting if set."
          persistent-hint
        />
        <div class="d-flex flex-column my-8">
          <enhanced-formula-builder
            v-model="zone.net_income_formula"
            label="Net Income Formula"
            :variables="formulaVariables"
            assigns-to="net_income"
          />
          <enhanced-formula-builder
            v-model="zone.management_commission_formula"
            label="Management Commission Formula"
            :variables="formulaVariables"
            assigns-to="management_commission"
          />
          <enhanced-formula-builder
            v-model="zone.owner_revenue_formula"
            label="Owner Profit Formula"
            :variables="formulaVariables"
            assigns-to="client_profit"
          />
          <v-select
            v-if="stripeItems.length"
            v-model="zone.stripe_account_id"
            :label="$t('Stripe account')"
            :items="stripeItems"
            outlined
            dense
          />
        </div>
        <!--        <v-text-field-->
        <!--          v-model="zone.booking_tax_rate"-->
        <!--          class="mt-2 mb-2"-->
        <!--          label="Total Booking Tax Rate"-->
        <!--          :disabled="!isAdmin"-->
        <!--          outlined-->
        <!--          dense-->
        <!--        />-->
        <!--        <v-text-field-->
        <!--          v-model="zone.store_tax"-->
        <!--          class="mt-2 mb-2"-->
        <!--          outlined-->
        <!--          dense-->
        <!--          label="Store tax"-->
        <!--          required-->
        <!--        />-->
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn small color="primary" outlined @click="closeModal">Cancel</v-btn>
        <v-btn small color="primary" type="submit">Save</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import formRules from 'components/mixins/form-rules-mixin'
import MultiPropertyPicker from 'components/multi-property-picker'
import PermissionsMixin from 'components/mixins/permissions-mixin'

import {
  NET_INCOME_FORMULAS,
  OWNER_REVENUE_FORMULAS,
  MANAGEMENT_COMMISSION_FORMULAS,
  formulaVariables,
} from '@/consts'
import CurrencyPicker from 'components/common/currency-picker.vue'
import EnhancedFormulaBuilder from 'components/common/enhanced-formula-builder.vue'

export default {
  name: 'ListingZoneModal',
  components: { EnhancedFormulaBuilder, CurrencyPicker, MultiPropertyPicker },
  mixins: [formRules, PermissionsMixin],
  props: ['zone'],
  data() {
    return {
      name: null,
      listingIds: [],
      NET_INCOME_FORMULAS,
      OWNER_REVENUE_FORMULAS,
      MANAGEMENT_COMMISSION_FORMULAS,
    }
  },
  mounted() {
    this.listingIds = this.listingsPicker
      .filter(l => l.zone_id === this.zone.id)
      .map(l => l.id)
  },
  computed: {
    ...mapGetters(['listingsPicker']),
    ...mapState('stripe', ['accounts']),
    stripeItems() {
      return this.accounts.map(a => ({ text: a.name, value: a.id }))
    },
    formulaVariables() {
      return formulaVariables
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('hideModal')
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('zones/updateZone', {
          id: this.zone.id,
          zone: this.zone,
          listings: this.listingIds,
        })
        this.closeModal()
      }
    },
  },
}
</script>

<style scoped></style>
